import React, { useState, useEffect, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { documentsActions } from "../../actions/documentsActions"

const CommentsDetailsModal = ({ commentsCount, commentList, docId, updateCommentCount = () => {} }) => {
	/* ******************* REDUX STORE ******************* */

	const dispatch = useDispatch()
	const authentication = useSelector((state) => state.authtentication)

	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	const [comment, setComment] = useState("")
	const [commentRandom, setCommentRandom] = useState(Math.random())
	const [idEditing, setIdEditing] = useState(null)
	const [commentEditing, setCommentEditing] = useState("")
	const [idElement, setIdElement] = useState(Math.random())
	/* ******************* END REACT STATES ******************* */

	/* ******************* VARIABLES ******************* */

	/* ******************* END VARIABLES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */

	const onChangeCommentInput = (e) => {
		setComment(e.target.value)
	}

	const eliminar = (comment_id, document_id) => {
		dispatch(documentsActions.deleteComment(comment_id, document_id))
		setIdElement(Math.random())
	}
	const edit = (comment_id, comment) => {
		setIdEditing(comment_id)
		setCommentEditing(comment)
		setIdElement(Math.random())
	}
	const cancelEdit = () => {
		setIdEditing(null)
		setCommentEditing("")
	}
	const save = () => {
		//dispatch(documentsActions.setPriorityCustomTagAction(nameEditing, colorIdEditing, idEditing));
		dispatch(documentsActions.addComment(docId, commentEditing, idEditing))
		cancelEdit()
	}

	const addTagSumbit = () => {
		dispatch(documentsActions.addComment(docId, comment))
		setComment("")
		setCommentRandom(Math.random())
	}
	/* ******************* END VARIABLES POST INITIALIZATION ******************* */

	return (
		<Fragment>
			<div id="comentarios_modal" className="col-12 divBlockModal mt-1" style={{ backgroundColor: "white" }}>
				<h5>
					{commentsCount} Comment{commentsCount === 1 ? null : "s"}
				</h5>

				<div className="">
					<form>
						<div className="col-12 divBlock">
							{commentList
								? commentList?.map((item) => (
										<Fragment key={item.comment_id}>
											<div
												className="col-12 divBlock d-flex justify-content-center mb-3"
												data-comment-id={item.comment_id}
											>
												<div className="card" style={{ width: "100%" }}>
													<div className="card-body">
														<h5 className="card-title" style={{ fontSize: "16px" }}>
															{item.user_name}
														</h5>
														{idEditing === item.comment_id &&
														item.user_id === authentication.user.token.userid ? (
															<textarea
																className="texterea-edit-comment"
																onChange={(e) => {
																	e.preventDefault()
																	setCommentEditing(e.target.value)
																}}
																defaultValue={commentEditing}
															></textarea>
														) : (
															<h6 className="card-subtitle mb-2 text-muted" style={{ fontSize: "14px" }}>
																{item.comment}
															</h6>
														)}
														<p className="card-text" style={{ fontSize: "12px" }}>
															{
																// new Intl.DateTimeFormat("es-ES", {
																//   year: "numeric",
																//   month: "2-digit",
																//   day: "2-digit",
																//   hour: "2-digit",
																//   minute: "2-digit",
																// }).format(new Date(item.creation_time))

																new Date(new Date(item.creation_time)).toLocaleString("en-US", {
																	year: "numeric",
																	month: "long",
																	day: "2-digit",
																	hour: "2-digit",
																	minute: "2-digit",
																})
															}
														</p>
													</div>
													{idEditing === item.comment_id ? (
														<Fragment>
															<div className="d-flex pb-2 pl-2">
																<button
																	disabled={commentEditing === "" ? true : false}
																	className="btn btn-primary btn-sm mr-2"
																	style={{ marginRight: "5px" }}
																	onClick={(e) => {
																		e.preventDefault()
																		save()
																	}}
																>
																	Save
																</button>
																<button
																	className="btn btn-danger btn-sm"
																	onClick={(e) => {
																		e.preventDefault()
																		cancelEdit()
																	}}
																>
																	Cancel
																</button>
															</div>
														</Fragment>
													) : item.user_id === authentication.user.token.userid ? (
														<Fragment>
															<div className="d-flex pb-2">
																<button
																	className="commentEliminar text-danger"
																	onClick={(e) => {
																		e.preventDefault()
																		eliminar(item.comment_id, item.doc_id)
																		updateCommentCount(docId, commentList.length - 1)
																	}}
																>
																	<i className="bi bi-trash"></i>
																</button>
																<button
																	className="commentEliminar text-primary"
																	onClick={(e) => {
																		e.preventDefault()
																		edit(item.comment_id, item.comment)
																	}}
																>
																	<i className="bi bi-pencil"></i>
																</button>
															</div>
														</Fragment>
													) : null}
												</div>
											</div>
										</Fragment>
								  ))
								: null}
						</div>
						<input
							type="text"
							className="form-control"
							placeholder="Add a comment"
							onChange={onChangeCommentInput}
							style={{ width: "85%", float: "left" }}
							value={comment}
							key={`coment_input_${commentRandom}`}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									e.preventDefault()
									addTagSumbit()
									updateCommentCount(docId, commentList.length + 1)
								}
							}}
						/>
						<button
							id="addCommentBtn"
							className="btn btn-primary btn-sm"
							disabled={comment === "" ? true : false}
							style={{
								float: "right",
								verticalAlign: "middle",
								marginTop: "20px",
							}}
							onClick={(e) => {
								e.preventDefault()
								addTagSumbit()
								updateCommentCount(docId, commentList.length + 1)
							}}
						>
							<i className="fas fa-paper-plane fa-rotate-90"></i>
						</button>
					</form>
				</div>
			</div>
		</Fragment>
	)
}

export default CommentsDetailsModal
